module.exports = __webpack_public_path__ + "static/photoshoot-02-16ddbfaf2c472fc0be605a04b670959a.png";